module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag == 'patient'),
      expression: "flag=='patient'"
    }],
    attrs: {
      "href": "/#/login"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('title')))])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag == 'hcp'),
      expression: "flag=='hcp'"
    }],
    attrs: {
      "href": "/#/hcpLogin"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('title1')))])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag == 'accountsmanagement'),
      expression: "flag=='accountsmanagement'"
    }],
    attrs: {
      "href": "/#/accountsmanagement"
    }
  }, [_c('span', [_vm._v("EasyView Accounts Managment")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag == 'clinic'),
      expression: "flag=='clinic'"
    }],
    attrs: {
      "href": "/#/clinic"
    }
  }, [_c('span', [_vm._v("EasyView Clinic")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCountry),
      expression: "showCountry"
    }],
    staticClass: "header-right",
    on: {
      "click": function($event) {
        _vm.languageFormVisible = true
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[0]),
      expression: "this.$store.state.country[0]"
    }],
    attrs: {
      "src": require("../../assets/England.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[1]),
      expression: "this.$store.state.country[1]"
    }],
    attrs: {
      "src": require("../../assets/China.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[2]),
      expression: "this.$store.state.country[2]"
    }],
    attrs: {
      "src": require("../../assets/France.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[3]),
      expression: "this.$store.state.country[3]"
    }],
    attrs: {
      "src": require("../../assets/German.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[4]),
      expression: "this.$store.state.country[4]"
    }],
    attrs: {
      "src": require("../../assets/Sweden.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[5]),
      expression: "this.$store.state.country[5]"
    }],
    attrs: {
      "src": require("../../assets/Australia.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[6]),
      expression: "this.$store.state.country[6]"
    }],
    attrs: {
      "src": require("../../assets/Hongkong.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[7]),
      expression: "this.$store.state.country[7]"
    }],
    attrs: {
      "src": require("../../assets/Hungary.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[8]),
      expression: "this.$store.state.country[8]"
    }],
    attrs: {
      "src": require("../../assets/Italy.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[9]),
      expression: "this.$store.state.country[9]"
    }],
    attrs: {
      "src": require("../../assets/Netherlands.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[10]),
      expression: "this.$store.state.country[10]"
    }],
    attrs: {
      "src": require("../../assets/Norway.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[11]),
      expression: "this.$store.state.country[11]"
    }],
    attrs: {
      "src": require("../../assets/Page 1.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[12]),
      expression: "this.$store.state.country[12]"
    }],
    attrs: {
      "src": require("../../assets/Spain.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[13]),
      expression: "this.$store.state.country[13]"
    }],
    attrs: {
      "src": require("../../assets/Turkey.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[14]),
      expression: "this.$store.state.country[14]"
    }],
    attrs: {
      "src": require("../../assets/Uniited Arab Emirates.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[15]),
      expression: "this.$store.state.country[15]"
    }],
    attrs: {
      "src": require("../../assets/Romania.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[16]),
      expression: "this.$store.state.country[16]"
    }],
    attrs: {
      "src": require("../../assets/Czech republic.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[17]),
      expression: "this.$store.state.country[17]"
    }],
    attrs: {
      "src": require("../../assets/Slovenska republika.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[18]),
      expression: "this.$store.state.country[18]"
    }],
    attrs: {
      "src": require("../../assets/Lithuania.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[19]),
      expression: "this.$store.state.country[19]"
    }],
    attrs: {
      "src": require("../../assets/Polska.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[20]),
      expression: "this.$store.state.country[20]"
    }],
    attrs: {
      "src": require("../../assets/Danmark.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[21]),
      expression: "this.$store.state.country[21]"
    }],
    attrs: {
      "src": require("../../assets/Suomi.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[22]),
      expression: "this.$store.state.country[22]"
    }],
    attrs: {
      "src": require("../../assets/Thailand.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[23]),
      expression: "this.$store.state.country[23]"
    }],
    attrs: {
      "src": require("../../assets/Indonesia.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[24]),
      expression: "this.$store.state.country[24]"
    }],
    attrs: {
      "src": require("../../assets/Malaysia.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[25]),
      expression: "this.$store.state.country[25]"
    }],
    attrs: {
      "src": require("../../assets/India.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[26]),
      expression: "this.$store.state.country[26]"
    }],
    attrs: {
      "src": require("../../assets/Switzerland.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[27]),
      expression: "this.$store.state.country[27]"
    }],
    attrs: {
      "src": require("../../assets/Saudi_Arabia.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[28]),
      expression: "this.$store.state.country[28]"
    }],
    attrs: {
      "src": require("../../assets/Uniited_Arab_Emirates.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[29]),
      expression: "this.$store.state.country[29]"
    }],
    attrs: {
      "src": require("../../assets/Qatar.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[30]),
      expression: "this.$store.state.country[30]"
    }],
    attrs: {
      "src": require("../../assets/Kuwait.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[31]),
      expression: "this.$store.state.country[31]"
    }],
    attrs: {
      "src": require("../../assets/flags/Croatia.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[32]),
      expression: "this.$store.state.country[32]"
    }],
    attrs: {
      "src": require("../../assets/flags/Austria.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[33]),
      expression: "this.$store.state.country[33]"
    }],
    attrs: {
      "src": require("../../assets/flags/Slovenia.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[34]),
      expression: "this.$store.state.country[34]"
    }],
    attrs: {
      "src": require("../../assets/flags/Estonia.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[35]),
      expression: "this.$store.state.country[35]"
    }],
    attrs: {
      "src": require("../../assets/flags/Latvia.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[36]),
      expression: "this.$store.state.country[36]"
    }],
    attrs: {
      "src": require("../../assets/flags/BIH.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[37]),
      expression: "this.$store.state.country[37]"
    }],
    attrs: {
      "src": require("../../assets/flags/Bulgaria.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[38]),
      expression: "this.$store.state.country[38]"
    }],
    attrs: {
      "src": require("../../assets/flags/Chile.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.country[39]),
      expression: "this.$store.state.country[39]"
    }],
    attrs: {
      "src": require("../../assets/flags/Belgium.png")
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[0].lang),
      expression: "this.$store.state.langs[0].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[1].lang),
      expression: "this.$store.state.langs[1].lang"
    }]
  }, [_vm._v("中文")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[2].lang),
      expression: "this.$store.state.langs[2].lang"
    }]
  }, [_vm._v("France")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[3].lang),
      expression: "this.$store.state.langs[3].lang"
    }]
  }, [_vm._v("German")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[4].lang),
      expression: "this.$store.state.langs[4].lang"
    }]
  }, [_vm._v("Sweden")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[5].lang),
      expression: "this.$store.state.langs[5].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[6].lang),
      expression: "this.$store.state.langs[6].lang"
    }]
  }, [_vm._v("繁体中文")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[7].lang),
      expression: "this.$store.state.langs[7].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[8].lang),
      expression: "this.$store.state.langs[8].lang"
    }]
  }, [_vm._v("Italian")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[9].lang),
      expression: "this.$store.state.langs[9].lang"
    }]
  }, [_vm._v("Dutch")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[10].lang),
      expression: "this.$store.state.langs[10].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[11].lang),
      expression: "this.$store.state.langs[11].lang"
    }]
  }, [_vm._v("Portuguese")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[12].lang),
      expression: "this.$store.state.langs[12].lang"
    }]
  }, [_vm._v("Spanish")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[13].lang),
      expression: "this.$store.state.langs[13].lang"
    }]
  }, [_vm._v("Türkçe")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[14].lang),
      expression: "this.$store.state.langs[14].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[15].lang),
      expression: "this.$store.state.langs[15].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[16].lang),
      expression: "this.$store.state.langs[16].lang"
    }]
  }, [_vm._v("Czech")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[17].lang),
      expression: "this.$store.state.langs[17].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[18].lang),
      expression: "this.$store.state.langs[18].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[19].lang),
      expression: "this.$store.state.langs[19].lang"
    }]
  }, [_vm._v("Polski")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[20].lang),
      expression: "this.$store.state.langs[20].lang"
    }]
  }, [_vm._v("Dansk")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[21].lang),
      expression: "this.$store.state.langs[21].lang"
    }]
  }, [_vm._v("Suomi")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[22].lang),
      expression: "this.$store.state.langs[22].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[23].lang),
      expression: "this.$store.state.langs[23].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[24].lang),
      expression: "this.$store.state.langs[24].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[25].lang),
      expression: "this.$store.state.langs[25].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[26].lang),
      expression: "this.$store.state.langs[26].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[27].lang),
      expression: "this.$store.state.langs[27].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[28].lang),
      expression: "this.$store.state.langs[28].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[29].lang),
      expression: "this.$store.state.langs[29].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[30].lang),
      expression: "this.$store.state.langs[30].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[31].lang),
      expression: "this.$store.state.langs[31].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[32].lang),
      expression: "this.$store.state.langs[32].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[33].lang),
      expression: "this.$store.state.langs[33].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[34].lang),
      expression: "this.$store.state.langs[34].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[35].lang),
      expression: "this.$store.state.langs[35].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[36].lang),
      expression: "this.$store.state.langs[36].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[37].lang),
      expression: "this.$store.state.langs[37].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[38].lang),
      expression: "this.$store.state.langs[38].lang"
    }]
  }, [_vm._v("English")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$store.state.langs[39].lang),
      expression: "this.$store.state.langs[39].lang"
    }]
  }, [_vm._v("English")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.languageFormVisible,
      "size": _vm.dialogSize,
      "id": "language-choose",
      "show-close": false,
      "top": "10%"
    },
    on: {
      "update:visible": function($event) {
        _vm.languageFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "language-choose-title",
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('chooseLang')))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/cancel.png")
    },
    on: {
      "click": _vm.cancelChoose
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "language-choose-body",
    slot: "default"
  }, [_c('div', {
    staticClass: "language-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('asia')))]), _vm._v(" "), _c('hr', {
    staticClass: "language-form-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Australia.png")
    }
  }), _c('span', [_vm._v("Australia -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(5, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language zhType"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/China.png")
    }
  }), _c('span', [_vm._v("中国 -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(1, 1)
      }
    }
  }, [_vm._v("中文简体")])])]), _vm._v(" "), _c('div', {
    staticClass: "language speLang2"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hongkong.png")
    }
  }), _c('span', [_vm._v("香港 (中国) -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(6, 6)
      }
    }
  }, [_vm._v("繁体中文")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Thailand.png")
    }
  }), _c('span', [_vm._v("Thailand -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(22, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Indonesia.png")
    }
  }), _c('span', [_vm._v("Indonesia -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(23, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Malaysia.png")
    }
  }), _c('span', [_vm._v("Malaysia -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(24, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/India.png")
    }
  }), _c('span', [_vm._v("India -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(25, 0)
      }
    }
  }, [_vm._v("English")])])])]), _vm._v(" "), _c('div', {
    staticClass: "language-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('europe')))]), _vm._v(" "), _c('hr', {
    staticClass: "language-form-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/France.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("France -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(2, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(2, 2)
      }
    }
  }, [_vm._v("France")])])]), _vm._v(" "), _c('div', {
    staticClass: "language speLang3"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/German.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("Deutschland -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(3, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(3, 3)
      }
    }
  }, [_vm._v("German")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Hungary.png")
    }
  }), _c('span', [_vm._v("Magyarország -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(7, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Italy.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("Italia -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(8, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(8, 8)
      }
    }
  }, [_vm._v("Italian")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Netherlands.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("Nederland -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(9, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(9, 9)
      }
    }
  }, [_vm._v("Dutch")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Norway.png")
    }
  }), _c('span', [_vm._v("Norge -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(10, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Page 1.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("Portugal -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(11, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(11, 11)
      }
    }
  }, [_vm._v("Portuguese")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Spain.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("España -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(12, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(12, 12)
      }
    }
  }, [_vm._v("Spanish")])])]), _vm._v(" "), _c('div', {
    staticClass: "language "
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Sweden.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("Sverige -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(4, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(4, 4)
      }
    }
  }, [_vm._v("Sweden")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Turkey.png")
    }
  }), _c('span', [_vm._v("Turkey -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(13, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(13, 13)
      }
    }
  }, [_vm._v("Türkçe")])])]), _vm._v(" "), _c('div', {
    staticClass: "language speLang3"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/England.png")
    }
  }), _c('span', [_vm._v("United Kingdom -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(0, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Romania.png")
    }
  }), _c('span', [_vm._v("Romania -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(15, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Czech republic.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("Czech republika -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(16, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(16, 16)
      }
    }
  }, [_vm._v("Czech")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Slovenska republika.png")
    }
  }), _c('span', [_vm._v("Slovenska republika -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(17, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Lithuania.png")
    }
  }), _c('span', [_vm._v("Lithuania -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(18, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Polska.png")
    }
  }), _c('span', [_vm._v("Polska -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(19, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(19, 19)
      }
    }
  }, [_vm._v("Polski")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Danmark.png")
    }
  }), _c('span', [_vm._v("Danmark -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(20, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(20, 20)
      }
    }
  }, [_vm._v("Dansk")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Suomi.png")
    }
  }), _c('span', [_vm._v("Suomi -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(21, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(21, 21)
      }
    }
  }, [_vm._v("Suomi")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Switzerland.png")
    }
  }), _c('span', [_vm._v("Switzerland -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(26, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/flags/Croatia.png")
    }
  }), _c('span', [_vm._v("Republika Hrvatska -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(31, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/flags/Austria.png")
    }
  }), _c('span', [_vm._v("Republik Österreich -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(32, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/flags/Slovenia.png")
    }
  }), _c('span', [_vm._v("Republika Slovenija -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(33, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/flags/Estonia.png")
    }
  }), _c('span', [_vm._v("Eesti Vabariik -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(34, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/flags/Latvia.png")
    }
  }), _c('span', [_vm._v("Latvijas Republika -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(35, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/flags/BIH.png")
    }
  }), _c('span', [_vm._v("Bosnia and Herzegovina -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(36, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/flags/Bulgaria.png")
    }
  }), _c('span', [_vm._v("Народна република България -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(37, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/flags/Belgium.png")
    }
  }), _c('span', [_vm._v("België -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(39, 0)
      }
    }
  }, [_vm._v("English")])])])]), _vm._v(" "), _c('div', {
    staticClass: "language-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('South America')))]), _vm._v(" "), _c('hr', {
    staticClass: "language-form-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/flags/Chile.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("República de Chile -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(38, 0)
      }
    }
  }, [_vm._v("English")]), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(38, 12)
      }
    }
  }, [_vm._v("Spanish")])])])]), _vm._v(" "), _c('div', {
    staticClass: "language-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('middleEast')))]), _vm._v(" "), _c('hr', {
    staticClass: "language-form-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Saudi_Arabia.png")
    }
  }), _c('span', [_vm._v("Saudi -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(27, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Uniited_Arab_Emirates.png")
    }
  }), _c('span', [_vm._v("Uniited Arab -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(28, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Qatar.png")
    }
  }), _c('span', [_vm._v("Qatar -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(29, 0)
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/Kuwait.png")
    }
  }), _c('span', [_vm._v("Kuwait -"), _c('label', {
    on: {
      "click": function($event) {
        _vm.languageChoose(30, 0)
      }
    }
  }, [_vm._v("English")])])])]), _vm._v(" "), _c('hr', {
    staticClass: "language-form-hr"
  })]), _vm._v(" "), _c('div', {
    staticClass: "language-choose-footer",
    slot: "footer"
  }, [_c('button', {
    on: {
      "click": _vm.cancelChoose
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/LOGO.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2175dcd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common-template/Header.vue
// module id = 1432
// module chunks = 7